import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const Styles = {
  HeaderContainer: styled('header')(({ theme }) => ({
    backgroundColor: 'black',
    width: '100%',
    height: '215px',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: 0,
    margin: '0 auto',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      padding: theme.spacing(2),
      flexDirection: 'column',
      alignItems: 'center'
    }
  })),

  GreenBar: styled('div')({
    backgroundColor: '#105330',
    width: '100%',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),

  // Outer wrapper inside GreenBar — space-between: spacer | tabs | actions
  NavLinksContainer: styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '1200px',
    width: '100%',
    padding: '0 24px'
  }),

  // Left empty spacer (mirrors the right actions width)
  GreenBarSpacer: styled('div')({
    flex: 1
  }),

  // Center — the actual tab links
  NavTabsGroup: styled('div')({
    display: 'flex',
    gap: '40px',
    justifyContent: 'center'
  }),

  // Right — logout action
  GreenBarActions: styled('div')({
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }),

  NavLink: styled(Link)(({ isactive }: { isactive: string }) => ({
    color: 'white',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '18px',
    padding: '0 20px',
    transition: 'color 0.2s',
    borderBottom: isactive === 'true' ? '4px solid white' : 'none',
    paddingBottom: '10px',
    '&:hover': {
      color: '#d4d4d4'
    }
  })),

  TextArea: styled('div')(({ theme }) => ({
    display: 'flex',
    marginLeft: '450px',
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      justifyContent: 'center',
      textAlign: 'center'
    }
  })),

  TextTop: styled('h1')(({ theme }) => ({
    color: 'white',
    fontWeight: 'bold',
    fontSize: '48px',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    }
  })),

  LogoArea: styled('div')(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2)
    }
  })),

  HeaderArea: styled('div')(({ theme }) => ({
    display: 'flex',
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  })),

  LogoImage: styled('img')(({ theme }) => ({
    height: '160px',
    paddingTop: '20px',
    position: 'absolute',
    left: '0',
    bottom: '0',
    marginBottom: '25px',
    zIndex: '1',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      height: '110px',
      paddingTop: 0,
      left: 'auto',
      bottom: 'auto',
      marginBottom: theme.spacing(1)
    }
  })),

  MobileContent: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingTop: '20px',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  })),

  MobileMenuButton: styled('button')(({ theme }) => ({
    position: 'absolute',
    right: '20px',
    top: '20px',
    background: 'transparent',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  })),

  // Novos componentes de estilo (padrão do projeto) – usando MUI styled
  ProfileArea: styled('div')({
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  }),

  ProfileBlock: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }),

  AvatarCircle: styled('button')({
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    border: '2px solid #04682e',
    background: 'transparent',
    overflow: 'hidden',
    cursor: 'pointer',
    padding: 0,
    display: 'grid',
    placeItems: 'center'
  }),

  AvatarImg: styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }),

  AvatarPlaceholder: styled('span')({
    color: '#8a8a8a',
    fontSize: '26px',
    lineHeight: 1
  }),

  ProfileName: styled('span')({
    marginTop: '6px',
    fontSize: '12px',
    color: '#ffffff',
    whiteSpace: 'nowrap'
  }),

  ProfileLink: styled(Link)({
    marginTop: '6px',
    fontSize: '12px',
    color: '#ffffff',
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    fontWeight: 600,
    '&:hover': {
      textDecoration: 'underline'
    }
  }),

  LogoutButton: styled('button')({
    background: '#ffffff',
    color: '#105330',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 14px',
    fontSize: '13px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    whiteSpace: 'nowrap',
    '&:hover': {
      opacity: 0.85
    }
  }),

  // Mobile-only bar below the Navbar with the logout button
  MobileLogoutBar: styled('div')(({ theme }) => ({
    display: 'none',
    backgroundColor: '#105330',
    width: '100%',
    padding: '8px 16px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  }))
};
